import { useState, useEffect } from "react"
import { v4 as uuid } from "uuid"
import { useShallow } from "zustand/react/shallow"

// components
import DynamicField from "components/form-fields//DynamicField/DynamicField"

import { PrimeButton, Select } from "components-design-system"
import CharCounter from "components/CharCounter/CharCounter"

// context
import useAuthoringViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringViewStore"

import "./Product.scss"

const Product = ({
  participantData,
  selectedArm,
  selectedProduct,
  schema,
  onCloseProduct,
  onUpdateProduct,
  onAddProduct,
}) => {
  const { readOnly, formView } = useAuthoringViewStore(
    useShallow((state) => ({
      readOnly: state.readOnly,
      formView: state.formView,
    }))
  )

  const [productListOptions, setProductListOptions] = useState([])
  const [productData, setProductData] = useState({})
  const [productListDetails, setProductListDetails] = useState([])
  const productSchema = schema.properties.eudract.properties.products.properties

  useEffect(() => {
    setProductData(selectedProduct)
  }, [selectedProduct])

  // keeps track of all products for copy
  useEffect(() => {
    if (participantData?.eudract_periods?.length > 0) {
      let productListDetails = []
      let productListOptions = []
      participantData.eudract_periods.forEach((period) => {
        if (period?.arms?.length > 0) {
          period.arms.forEach((arm) => {
            if (arm?.products?.length > 0) {
              arm.products.forEach((product) => {
                let label = `${period.title} / ${arm.title} / ${product.imp_name}`
                productListOptions.push({
                  id: product.id,
                  text: label || "NA",
                })
                productListDetails.push({
                  ...product,
                })
              })
            }
          })
        }
      })

      setProductListDetails(productListDetails)
      setProductListOptions(productListOptions)
    }
  }, [participantData])

  const onCopyProduct = (e) => {
    let foundProduct = productListDetails.find((product) => product.id === e.id)

    if (foundProduct) {
      let copiedProduct = {
        ...foundProduct,
        id: `product-${uuid()}`,
      }
      setProductData(copiedProduct)
    }
  }

  const handleChange = (e, key) => {
    let temp = { ...productData }
    temp[key] = e
    setProductData(temp)
  }

  const onCloseModal = () => {
    onCloseProduct()
    setProductData({})
  }

  const onSubmit = () => {
    if (selectedProduct) onUpdateProduct({ selectedArm, product: productData })
    else onAddProduct({ selectedArm, product: productData })
    onCloseModal()
  }

  return (
    <div className="product-modal-content">
      {readOnly !== true && (
        <Select
          label="Copy product"
          readOnly={readOnly}
          options={productListOptions}
          value={null}
          onChange={(e) => {
            let foundItem = productListOptions.find((item) => item.id === e)
            onCopyProduct(foundItem)
          }}
        />
      )}
      {Object.keys(productSchema).map((key, i) => {
        return (
          <div
            key={`${key}-${i}`}
            className="product-field-container"
          >
            <DynamicField
              type={productSchema[key].type}
              fieldProps={{
                style: { width: "100%" },
                label: productSchema[key].title,
                readOnly: readOnly,
                options: productSchema[key].options,
                value: productData?.[key],
                onChange: (e) => handleChange(e, key),
              }}
            />
            {productSchema[key].charCountEnabled && formView.id !== "global" && (
              <div className="char-counter-container">
                <CharCounter
                  value={productData?.[key]}
                  maxChars={productSchema[key].maxChars}
                />
              </div>
            )}
          </div>
        )
      })}
      <div style={{ display: "flex", gap: 8, justifyContent: "center", marginTop: 24 }}>
        <PrimeButton onClick={() => onCloseModal()}>Cancel</PrimeButton>
        <PrimeButton
          type="primary"
          onClick={() => onSubmit()}
        >
          Save
        </PrimeButton>
      </div>
    </div>
  )
}

export default Product
